import axios from 'axios'

export default {
  generatePdf(html) {
    return axios.post(window.VUE_CLI_EXPORTS.settings.PdfGeneratorUrl + '/pdf/generate', html, {
      responseType: 'arraybuffer',
    })
  },
  async GetConceptPdf(quoteId) {
    try {
      const response = await axios.get(`GetConceptPdf?quoteId=${quoteId}`, {
        responseType: 'blob',
      })
      let fileName = response.headers['content-disposition']
        .split('filename=')[1]
        .split(';')[0]
        .replace(/"/g, '')
      return {
        pdfContent: response.data,
        fileName: fileName,
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async GetOfferPdf(quoteId) {
    try {
      const response = await axios.get(`GetQuotePdf?quoteId=${quoteId}`, {
        responseType: 'blob',
      })

      let fileName = response.headers['content-disposition']
        .split('filename=')[1]
        .split(';')[0]
        .replace(/"/g, '')
      return {
        pdfContent: response.data,
        fileName: fileName,
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async GetOrderPdf(quoteId) {
    try {
      const response = await axios.get(`GetOrderPdf?quoteId=${quoteId}`, {
        responseType: 'blob',
      })
      let fileName = response.headers['content-disposition']
        .split('filename=')[1]
        .split(';')[0]
        .replace(/"/g, '')
      return {
        pdfContent: response.data,
        fileName: fileName,
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async GetChangeOrderPdf(changeOrderId) {
    try {
      const response = await axios.get(`GetChangeOrderPdf?changeOrderId=${changeOrderId}`, {
        responseType: 'blob',
      })
      let fileName = response.headers['content-disposition']
        .split('filename=')[1]
        .split(';')[0]
        .replace(/"/g, '')
      return {
        pdfContent: response.data,
        fileName: fileName,
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async GenerateHtmlToPdf(htmlBody, fileName, documentType) {
    try {
      const response = await axios.post(
        `GenerateHtmlToPdf`,
        {
          htmlBody: htmlBody,
          fileName: fileName,
          documentType: documentType,
        },
        {
          responseType: 'blob',
        }
      )
      return {
        pdfContent: response.data,
        fileName: fileName,
      }
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
